// todo: break this into separate files for each area of functionality
export enum MiscTopic {
    DEBUG = 'debug',

    RoipRadioReceive = 'roip/+/radio-receive/+',
    RoipRadioText = 'roip/+/radio-text/+',

    // user topics

    UserAccountAdded = 'user/+/account-added',
    UserAccountRemoved = 'user/+/account-removed',
    UserNotification = 'user/+/notification',
    UserStream = 'user/+/stream',
    UserAudioStream = 'user/+/audio-stream',
    UserAudioMimi = 'user/+/audio-mimi',
    UserBadgeUpdate = 'user/+/badge-update',
    UserLocaleChange = 'user/+/locale-change',

    // PTT topics

    AccountAudioStart = 'account/+/audio/+/start',
    AccountAudioOffline = 'account/+/audio/+/offline',
    AccountAudioSend = 'account/+/audio/+/send',
    AccountAudioReceive = 'account/+/audio/+/receive',
    UserAudioStart = 'user/+/audio/+/start',
    UserAudioOffline = 'user/+/audio/+/offline',
    UserAudioSend = 'user/+/audio/+/send',
    UserAudioReceive = 'user/+/audio/+/receive',
    PttTelemetry = 'user/+/ptt-telemetry',
    PttTelemtry = 'user/+/ptt-telemtry', /** @deprecated misspelled topic can be removed after all clients are on 5.16 or later */

    // PTT isolation topics - standalone traffic for the ptt-service (frontend publishes ingest later;
    // ptt-service publishes output later).
    //
    // The sender's identity is carried by the topic, not the payload: ptt-service consumes these with a
    // service account and so has no per-message authenticated user, and a payload field would be
    // sender-supplied. The broker grants a client only its own ids — `account/{accountId}/person/{userId}`
    // and `user/{userId}` — so both segments are authenticated the same way `user/${user.userId}/#` is
    // today. Account form: '+' = accountId, personId, PTT stream id. User form: '+' = userId, stream id.
    PttIsolationAccountAudioStart = 'ptt-isolation/account/+/person/+/audio/+/start',
    PttIsolationAccountAudioSend = 'ptt-isolation/account/+/person/+/audio/+/send',
    PttIsolationAccountAudioOffline = 'ptt-isolation/account/+/person/+/audio/+/offline',
    PttIsolationAccountAudioReceive = 'ptt-isolation/account/+/person/+/audio/+/receive',
    PttIsolationUserAudioStart = 'ptt-isolation/user/+/audio/+/start',
    PttIsolationUserAudioSend = 'ptt-isolation/user/+/audio/+/send',
    PttIsolationUserAudioOffline = 'ptt-isolation/user/+/audio/+/offline',
    PttIsolationUserAudioReceive = 'ptt-isolation/user/+/audio/+/receive',

    // Voice assistant topics

    UserVoiceAssistantStart = 'user/+/voice-assistant/+/start',
    UserVoiceAssistantSend = 'user/+/voice-assistant/+/send',
    UserVoiceAssistantReceive = 'user/+/voice-assistant/receive',

    // Speech to Text topics
    UserSpeechToTextStart = 'user/+/speech-to-text/+/start',
    UserSpeechToTextSend = 'user/+/speech-to-text/+/send',
    UserSpeechToTextReceive = 'user/+/speech-to-text/receive',

    // Map-related topics (usually pretty high impact)

    AccountPersonBadgeUpdated = 'account/+/person/+/badge/updated',
    AccountPersonFacilitiesUpdated = 'account/+/person/+/facilities/updated',

    AccountFacilityAlertPersonUpdated = 'account/+/facility/+/facility-alert/+/person-updated',
    AccountFacilityPersonBadgeUpdated = 'account/+/facility/+/person/+/badge/updated',
    AccountPersonNotification = 'account/+/person/+/notification',
    AccountPersonAudio = 'account/+/person/+/audio',
    AccountPersonBadgeDeregistered = 'account/+/person/+/badge/deregistered',
    AccountPersonBadgeEvent = 'account/+/person/+/badge/event',
    AccountPersonLogout = 'account/+/person/+/logout',
    AccountWaltBadgeEvent = 'account/+/walt/+/badge/event',
    AccountFacilityGeofenceEvent = 'account/+/facility/+/geofence/+/event',
    AccountFacilityCommunication = 'account/+/facility/+/communication',

    // Cache update topics
    AccountPersonPermissionsUpdated = 'account/+/person/+/permissions/updated',
    AccountFolderUpdated = 'account/+/folder/+/updated',
    AccountFacilityUpdated = 'account/+/facility/+/updated',
    AccountRuleUpdated = 'account/+/rule/+/updated',
    AccountFacilityGroupUpdated = 'account/+/facility/+/group/+/updated',
    AccountFacilityCustomDictionaryUpdated = 'account/+/facility/+/custom-dictionary-updated',
    AccountGeofenceUpdated = 'account/+/geofence/+/updated',
    AccountSettingsUpdated = 'account/+/settings/updated',
    AccountProductPackagesUpdated = 'account/+/packages/updated',
    ProductPackageDefinitionsUpdated = 'package-definitions/updated',

    // Update topics

    AccountFeaturesUpdated = 'account/+/features/updated',
    AccountPersonUpdated = 'account/+/person/+/updated',
    AccountFacilityPersonUpdated = 'account/+/facility/+/person/+/updated',
    AccountPeopleUpdated = 'account/+/people-updated',
    AccountUsers = 'account/+/users',
    AccountPersonEventRequest = 'account/+/person/+/event/+/request',
    AccountPersonEvent = 'account/+/person/+/event',
    AccountItems = 'account/+/items',
    AccountWaltEvent = 'account/+/walt/+/event',
    AccountWaltPersonEvent = 'account/+/walt/+/person/+/event', // Note: this should be reviewed, it allows a walt to act as any person on its assigned account.
    AccountCraftUpdated = 'account/+/craft/+/updated',
    AccountCustomDictionaryUpdated = 'account/+/custom-dictionary/+/updated',
    AccountCompanyUpdated = 'account/+/company/+/updated',
    AccountAlertTypeUpdated = 'account/+/alert-type/+/updated',
    AccountStatusUpdated = 'account/+/status/+/updated',
    AccountReportUpdated = 'account/+/report/+/updated',
    AccountReportTemplateUpdated = 'account/+/report-template/+/updated',
    AccountSafetyObservationUpdated = 'account/+/safety-observation/+/updated',
    AccountSafetyObservationTimelineEvents = 'account/+/safety-observation/+/timeline-events',

    UserNotificationCreated = 'user/+/notification-created',
    UserPersonConnection = 'user/+/person-connection',
    AccountFacilityPersonNotification = 'account/+/facility/+/person/+/notification',
    AccountFacilityPersonNotificationUpdated = 'account/+/facility/+/person/+/notification-updated',
    AccountPersonPersonConnection = 'account/+/person/+/person-connection',
    AccountPersonNotificationCreated = 'account/+/person/+/notification-created',
    AccountPersonNotificationUpdated = 'account/+/person/+/notification-updated',

    // Forms

    AccountFormSubmission = 'account/+/forms/+/submissions',

    // Dashboard data sources

    AccountDataSourceSql = 'account/+/data-source/+/sql/#',
    AccountDataSourceSimpleSql = 'account/+/data-source/+/simple-sql/#',
    AccountStaticSourceSql = 'account/+/static-source/+/sql/#',
    AccountFacilityAlertTypeUpdated = 'account/+/facility/+/alert-type-updated',

    // walt stuff

    WaltUpdated = 'walt/+/updated', // TODO: Secure this topic so we don't send sensitive data https://weavix.atlassian.net/browse/WK-1280
    AccountWaltUpdated = 'account/+/walt/updated',
    WaltLogout = 'walt/+/logout',
    WaltLogs = 'walt/+/logs',
    WaltSound = 'walt/+/sound', // plays the find-device locate sound to help locate a lost walt
    WaltStopSound = 'walt/+/sound-stop', // tells the walt to stop the find-device locate sound
    AccountWaltSoundStatus = 'account/+/walt/+/sound-status', // relays play-sound acknowledgment status to the console
    WaltClearWifis = 'walt/+/clear-wifis', // clears user saved WIFIs and resets to site config
    WaltConnectionLogs = 'walt/+/connection-logs',
    WaltRefresh = 'walt/+/refresh', // triggers a refresh of the walt state from the console
    WaltReboot = 'walt/+/reboot', // tells the walt to restart, sent from the console
    WaltPowerOff = 'walt/+/power-off', // tells the walt to power off, sent from the console
    WaltInstallUpdate = 'walt/+/install-update', // tells the walt to install its required version and restart, sent from the console

    AccountFeatureFlags = 'features/+/feature-flags',
    FeatureUpdates = 'features/defaults',

    // Map things update topics (used by console -- could use sync instead)
    AccountMapGeofences = 'account/+/map/geofences',
    AccountMapFloorPlans = 'account/+/map/floor-plans',
    AccountMapFacilities = 'account/+/map/facilities',
    AccountMapBuildings = 'account/+/map/buildings',
    AccountMapStructures = 'account/+/map/structures',

    // mesh things
    SelfMeshSend = 'self/+/mesh-send',
    WaltMeshReceive = 'walt/+/mesh-receive',

    // Legacy query build (can remove)

    AccountDataSourceCollection = 'account/+/data-source/+/collection/#',
    AccountStaticSourceCollection = 'account/+/static-source/+/collection/#',

    // @unused (some are used by integration tests though)
    UserChannelMessageCreated = 'user/+/channel-message-created',
    UserChannelTypers = 'user/+/channel/+/typers',

    UserFacilityAlertCreated = 'user/+/facility-alert-created',
    UserSetting = 'user/+/setting/+',
    UserFakeLocation = 'user/+/fake-location',
    UserSendLogs = 'user/+/send-logs',
    UserRingbacks = 'user/+/ringbacks',

    AccountPersonChannelMessageCreated = 'account/+/person/+/channel-message/created',
    UserChannelFavoritesUpdated = 'user/+/channel-favorites/updated',
    AccountPersonFacilityAlertCreated = 'account/+/person/+/facility-alert/created',
    AccountPersonFaceUpdated = 'account/+/person/+/face/updated',

    AccountChannelTypers = 'account/+/channel/+/typers',
    AccountTagUpdated = 'account/+/tag/+/updated',

    AccountFacilityPersonStatusUpdated = 'account/+/facility/+/person/+/status/updated',

    AccountPersonLocationUpdate = 'account/+/person/+/location-update',
    UserTelemetry = 'user/+/telemetry',
    SelfTelemetry = 'self/+/telemetry',
    SelfDownload = 'self/+/download/+',
    SelfUpload = 'self/+/upload',
}
